import Head from 'next/head'
import Link from 'next/link';
import { motion } from 'framer-motion';
import BannerWithGraphic from "../../components/common/BannerWithGraphic";
import styles from '../../styles/modules/common/sitemap.module.scss';
import Config from '../../config';
import { getStaticPath } from '../../utils';
import { getCityWiseSlugMappings, getCityDisplayName } from '../../utils/cities';
import React from 'react';
import { trackPage } from '../../tracking';
import { getPageViewData } from '../../utils/tracking';
import page_data from '../../data/page_data';
import category_links from '../../data/category_links';

const Fetcher = async () => {
  const data = {
    category_links: category_links || [],
    meta_tag_data: page_data["\\"].meta_tag ? page_data["\\"].meta_tag : [],
    device_city_pages: getCityWiseSlugMappings()
  }
  return data;
};

export async function getServerSideProps() {
  const data = await Fetcher()
  return {
    props: { ...data, pageName: 'sitemap'}
  }
}

const Sitemap = (props: any) => {
  const BASE_URL = Config.BASE_URL;
  const OG_IMAGE = getStaticPath("/static/images/why-onsitego.png")
  const category_keys = Object.keys(props.category_links).sort();

  React.useEffect(()=>{
    trackPage('Sitemap',{...getPageViewData()})
  },[])
  return (
    <motion.div className="app-base" initial="pageInitial" animate="pageAnimate" variants={{
      pageInitial: {
        opacity: 0
      },
      pageAnimate: {
        opacity: 1
      }
    }}>
      <>
        <Head>
          <title>{props.meta_tag_data.tag_title}</title>
          <link rel="icon" href="/favicon.ico" />
          <meta name="description" content={props.meta_tag_data.tag_description}></meta>
          <meta property="og:title" content={props.meta_tag_data.tag_title} />
          <meta property="og:description" content={props.meta_tag_data.tag_description} />
          <meta property="og:url" content={`${BASE_URL}`} />
          <meta property="og:image" content={OG_IMAGE} />
          <link rel="canonical" href={`${BASE_URL}`}></link>
        </Head>
        <main className={styles.sitemap_container}>
          <BannerWithGraphic
            title='Onsitego Sitemap'
            subtitle=''
            banner_img="/static/images/home/banner/banner-right.svg"
            journeyType="Sitemap"
          />
          <div className='odd-even-start-with-gray'>
            <section className={styles.content_holder}>
              <div className='container'>
              <h5>Device &amp; Plans</h5>
                <div className={`row ${styles.links}`}>
                  {
                    category_keys.map(key => {
                      return (
                        <div key={key} className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}>
                          <p className={'title'}>{key}</p>
                          <ul>
                            {
                              props.category_links[key].map(item => <li key={item.url}><Link href={`/${item.url}`} legacyBehavior>{item.plan}</Link></li>)
                            }
                          </ul>
                        </div>
                      );
                    })
                  }
                </div>
              </div>
            </section>
            {/* <section className={styles.content_holder}>
              <div className='container'>
              <h5>City wise Device &amp; Plans</h5>
                <div className={`row ${styles.links}`}>
                  {
                    Object.keys(props.device_city_pages).map(key => {
                      let device_pages = props.device_city_pages[key]
                      return (
                        <div key={key} className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}>
                          <p className={'title'}>{key}</p>
                          <ul>
                            {
                              device_pages.map(item => <li key={item.slug}><Link href={item.slug} legacyBehavior>{getCityDisplayName(item.city)}</Link></li>)
                            }
                          </ul>
                        </div>
                      );
                    })
                  }
                </div>
              </div>
            </section> */}
            <section className={styles.content_holder}>
              <div className='container'>
                <h5><Link href="/">Onsitego</Link></h5>
                <div className={`row ${styles.links}`}>
                  <div className={`${styles.device} col-12`}>
                      <div className={`row`}>
                        <div className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}><Link href='/selfserve/tracker'>Track Service Request</Link></div>
                        <div className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}><Link href='/request-a-service/login'>Login</Link></div>
                        <div className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}><Link href='/selfserve'>Raise Service Request</Link></div>
                        <div className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}><Link href='/salespro-app-for-retailers'>Salespro App for Retailers</Link></div> 
                      </div>
                  </div>
                </div>
              </div>
            </section>
            <section className={styles.content_holder}>
              <div className='container'>
                <h5>Company</h5>
                <div className={`row ${styles.links}`}>
                  <div className={`${styles.device} col-12`}>
                    <div className={`row`}>
                      <div className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}><Link href='/about-us'>About Us</Link></div>
                      <div className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}><Link href='/blog'>Blog</Link></div>
                      <div className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}><Link href='/careers'>Careers</Link></div>
                      <div className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}><Link href='/media'>In The Media</Link></div>
                      <div className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}><Link href='/whitepapers'>Whitepapers</Link></div>
                      <div className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}><Link href='/write-to-us'>Contact Us</Link></div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className={styles.content_holder}>
              <div className='container'>
                <h5>Policies</h5>
                <div className={`row ${styles.links}`}>
                  <div className={`${styles.device} col-12`}>
                    <div className={`row`}>
                      <div className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}><Link href='/terms-of-use'>Terms Of Use</Link></div>
                      <div className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}><Link href='/privacy-policy'>Privacy Policy</Link></div>
                      <div className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}><Link href='/terms-of-service/website'>Cancellations</Link></div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className={styles.content_holder}>
              <div className='container'>
                <h5>Warranty Check</h5>
                <div className={`row ${styles.links}`}>
                  <div className={`${styles.device} col-12`}>
                    <div className={`row`}>
                      <div className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}><Link href='/blog/apple-warranty-check'>Apple Warranty Check</Link></div>
                      <div className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}><Link href='/blog/iphone-warranty-check'>Iphone Warranty Check</Link></div>
                      <div className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}><Link href='/blog/dell-warranty-check'>Dell Warranty Check</Link></div>
                      <div className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}><Link href='/blog/sony-warranty-check'>Sony Warranty Check</Link></div>
                      <div className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}><Link href='/blog/lenovo-warranty-check'>Lenovo Warranty Check</Link></div>
                      <div className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}><Link href='/blog/samsung-warranty-check'>Samsung Warranty Check</Link></div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* -------------Commented out LSP Partners block. Re-enable when needed for website display.---------*/}
            {/* <section className={styles.content_holder}>
              <div className='container'>
                <h5>Lending Service Provider</h5>
                <div className={`row ${styles.links}`}>
                  <div className={`${styles.device} col-12`}>
                    <div className={`row`}>
                      <div className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}><Link href='/customer-consent'>Customer Consent</Link></div>
                      <div className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}><Link href='/grievance-redressal'>Grievance Redressal</Link></div>
                      <div className={`${styles.device} col-6 col-sm-4 col-md-3 col-xs-2`}><Link href='/lending-service-partners'>LSP Partners</Link></div>
                    </div>
                  </div>
                </div>
              </div>
            </section> */}
          </div>
        </main>
      </>
    </motion.div>
  );
}

export default Sitemap;
